import styled from 'styled-components'

export const UserWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
  padding: 0 10px;
`

export const AvatarWrapper = styled.span`
  align-self: flex-start;
  display: block;
  margin-right: 10px;
`
